import wareWhitePng from "@/assets/Ware-White.png";

const sidebarItem = (t, usefulLinks = []) => [
    {
        title: t("sidebar.wares"),
        icon: "mdi-package-variant",
        to: "/dashboard/search-wares",
        children: [
            {
                title: t("sidebar.publishWare"),
                iconImg: wareWhitePng,
                to: "/dashboard/publish-ware",
            },
            {
                title: t("sidebar.myWares"),
                icon: "mdi-truck-fast",
                to: "/dashboard/my-wares",
            },
            {
                title: t("sidebar.searchWares"),
                icon: "mdi-magnify",
                to: "/dashboard/search-wares",
            },
        ],
    },
    {
        title: t("sidebar.trucks"),
        icon: "mdi-truck",
        to: "/dashboard/search-trucks",
        children: [
            {
                title: t("sidebar.publishTruck"),
                icon: "mdi-truck-plus",
                to: "/dashboard/publish-truck",
            },
            {
                title: t("sidebar.myTrucks"),
                icon: "mdi-truck-check",
                to: "/dashboard/my-trucks",
            },
            {
                title: t("sidebar.searchTrucks"),
                icon: "mdi-magnify",
                to: "/dashboard/search-trucks",
            },
        ],
    },
    { divider: true },
    {
        title: t("sidebar.incidents"),
        icon: "mdi-alert",
        to: "/dashboard/my-incidents",
        children: [
            {
                title: t("incidents.title"),
                icon: "mdi-alert",
                to: "/dashboard/my-incidents",
            },
            {
                title: t("incidents.otherCompaniesIncidents"),
                icon: "mdi-alert",
                to: "/dashboard/other-company-incidents",
            },
            {
                title: t("sidebar.addPaymentIncident"),
                icon: "mdi-credit-card-outline",
                to: "/dashboard/add-payment-incident",
            },
            {
                title: t("sidebar.addTruckIncident"),
                icon: "mdi-truck-alert",
                to: "/dashboard/add-transport-incident",
            },
        ],
    },
    {
        title: t("landingPage.usefulLinks"),
        icon: "mdi-link-variant",
        to: "/dashboard/useful-links",
    },
    { divider: true },
    {
        title: t("sidebar.settings"),
        icon: "mdi-cog",
        to: "/dashboard/company-details",
        children: [
            {
                title: t("sidebar.employees"),
                icon: "mdi-account-group",
                to: "/dashboard/employees",
            },
            {
                title: t("sidebar.companyDetails"),
                icon: "mdi-office-building",
                to: "/dashboard/company-details",
            },
            {
                title: t("sidebar.companyCheck"),
                icon: "mdi-domain",
                to: "/dashboard/company-search",
            },
        ],
    },
    {
        title: t("sidebar.logout"),
        icon: "mdi-logout",
        type: "logout",
    },
    {
        title: t("sidebar.help"),
        icon: "mdi-help-circle",
        type: "action",
        action: () => window.open("mailto:ioannasui@mekonsm.ro", "_blank"),
    },
];

export default sidebarItem;